var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.textalign},[_c('div',[_vm._v(_vm._s(_vm._f("moneyFormat")(_vm.value,_vm.currency, _vm.decimals))),_c('span',{staticClass:"no-copy"},[_vm._v(" "+_vm._s(_vm.currency))])])])}
var staticRenderFns = []

export { render, staticRenderFns }